import Database from "@/controller/database";
import UploadInspecttion from "@/services/transmission/uploadService";
import logger from "@/services/vex/logger";
import store from "@/store/store";

class UploadController {
    upload = new UploadInspecttion();
    database = new Database();

    async uploadJson(inspection, event) {
        const inspectionJson = JSON.parse(JSON.stringify(inspection));
        
        const nonSignaturePhotos = inspectionJson.inspectionData.photos.filter(photo => {
            return photo.image_name !== "Cliente" && photo.image_name !== "Vistoriador";
        });
        
        const photosObj = nonSignaturePhotos.map(photo => {
            return {
                avarias: 0,
                comentario: "",
                id_template: photo.template_id || 0,
                id_vistoria: 0,
                nome_foto: photo.image_name + ".jpg",
                registrado_em: photo.timestamp
            };
        });

        delete inspectionJson.inspectionData.photos;
        delete inspectionJson.inspectionData.requiredPhotos;
        delete inspectionJson.inspectionData.breakdownPhotos;
        delete inspectionJson.inspectionData.additionalPhotos;
        delete inspectionJson.inspectionData.templates;
        delete inspectionJson.inspectionData.signatures;
        delete inspectionJson.inspectionData.clientSignaturePoints;
        delete inspectionJson.inspectionData.inspectorSignaturePoints;
        delete inspectionJson.inspectionData.photoNoEdit;

        await this.upload
            .sendInspection(inspectionJson, photosObj)
            .then((res) => {
                if (res.status === 200) {
                    store.commit(
                        "updateLogArray",
                        `JSON da placa ${inspectionJson.inspectionData.numberPlate} - ENVIADO`
                    );
                    inspection.status = "Enviado";
                    this.database.updateInspectionOnDatabase(event, inspection);
                }
            })
            .catch((error) => {
                console.error(error);
                store.commit(
                    "updateLogArray",
                    `JSON da placa ${inspectionJson.inspectionData.numberPlate} - FALHA NO ENVIO: ${error}`
                );
            });
    }

    async uploadDataToEndpoints(inspection, event) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            try {
                const vist_id = inspection.id_vistoria;
                const plate = inspection.inspectionData.numberPlate;
                const photos = inspection.inspectionData.photos;
                const signatures = inspection.inspectionData.signatures;
                let fotosEnviadas = false;
                let assinatura = "";

                photos.forEach((photo) => {
                    if (photo.image_name === "Cliente") {
                        assinatura = photo.image_name;
                    } else if (photo.image_name === "Vistoriador") {
                        assinatura = photo.image_name;
                    }
                });

                let inclui =
                    assinatura.includes("Cliente") || assinatura.includes("Vistoriador");

                if (!inclui) {
                    signatures.forEach((signature) => {
                        photos.push(signature);
                    });
                }

                var counter = 1;
                var numeroImgs = photos.length;

                store.commit(
                    "updateLogArray",
                    `Iniciando o envio das imagens da placa ${plate}`
                );
                for await (let photo of photos) {
                    store.commit(
                        "updateLogArray",
                        `Enviando imagem ${counter} de ${numeroImgs}`
                    );
                    photo.vist_id = vist_id;
                    try {
                        const uploadResult = await this.upload.uploadInspectionPhotos(
                            photo
                        );
                        if (uploadResult.status === 200) {
                            fotosEnviadas = true;
                            store.commit(
                                "updateLogArray",
                                `${
                                    photo.nomePhoto ? photo.nomePhoto : photo.image_name
                                } - ENVIADO`
                            );
                        }
                    } catch (error) {
                        fotosEnviadas = false;
                        store.commit(
                            "updateLogArray",
                            `${
                                photo.nomePhoto ? photo.nomePhoto : photo.image_name
                            } - FALHA NO ENVIO: ${error}`
                        );

                        error.message = "Problema ao enviar foto. Erro: " + error.message;
                        if(error?.config?.data){
                            error.config.data = JSON.parse(error.config.data);
                            if(error.config.data?.image_base64)
                                error.config.data.image_base64 = "OMITIDA";
                        }
                        logger(error);
                        reject(error);
                        break;
                    }

                    await this.sleep(2000);
                    counter++;
                }
                if (fotosEnviadas) {
                    await this.uploadJson(inspection, event);
                    resolve();
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    async sendAllPendingInspectionsToServer(event) {
        const database = new Database();
        return new Promise((resolve, reject) => {
            database
                .getAllPendingInspections(event)
                .then(async (pendingInspections) => {
                    for await (let inspection of pendingInspections) {
                        try {
                            await this.uploadDataToEndpoints(inspection, event);
                            await this.sleep(1000);
                        } catch (error) {
                            if(error.data){
                                error.data = JSON.parse(error.data);
                            }
                            logger(error);
                            reject(error);
                        }
                    }
                    resolve();
                })
                .catch((err) => {
                    err.message = "Problemas ao enviar vistorias pendentes. Erro: " + err.message;
                    if(err?.config?.data){
                        err.config.data = JSON.parse(err.config.data);
                    }
                    logger(err);
                    reject(err);
                });
        });
    }

    async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}

export default UploadController;
